<script>
import Swal from 'sweetalert2';

export default {
    props: {
        eventoId: {
            type: [Number, String],
            default: null,
        },
        eventoCodigo: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            asistentes: [],
            cargando: false,
            error: '',
            busquedaCodigo: '',
            busquedaTimer: null,
            eliminandoId: null,
            total: 0,
            totalGeneral: 0,
            puedeGestionarCrm: false,
            enviandoCrm: false,
            formularioVigente: false,
            formularioCerrado: false,
            filtroCrm: 'todos',
            resumenCrm: {},
            pollingCrmTimer: null,
            solicitudActual: 0,
            clicsActividadesDifusion: 0,
            paginacion: {
                paginaActual: 1,
                ultimaPagina: 1,
                porPagina: 50,
                desde: 0,
                hasta: 0,
            },
        };
    },
    computed: {
        totalProgramableCrm() {
            return Number(this.resumenCrm.crm_pendientes || 0) + Number(this.resumenCrm.crm_errores || 0);
        },
        crmProcesados() {
            return Number(this.resumenCrm.crm_enviados || 0) + Number(this.resumenCrm.crm_errores || 0);
        },
        crmProgreso() {
            return this.totalGeneral ? Math.round(this.crmProcesados * 100 / this.totalGeneral) : 0;
        },
        linkFormularioEvento() {
            if (!this.eventoCodigo) {
                return '';
            }

            return `${window.location.origin}/credencialdigital/${encodeURIComponent(this.eventoCodigo)}`;
        },
    },
    watch: {
        eventoId: {
            immediate: true,
            handler() {
                this.detenerPollingCrm();
                this.asistentes = [];
                this.resumenCrm = {};
                this.totalGeneral = 0;
                this.puedeGestionarCrm = false;
                this.formularioVigente = false;
                this.formularioCerrado = false;
                this.paginacion.paginaActual = 1;
                this.cargarAsistentes();
            },
        },
        busquedaCodigo() {
            clearTimeout(this.busquedaTimer);
            this.busquedaTimer = setTimeout(() => {
                this.paginacion.paginaActual = 1;
                this.cargarAsistentes();
            }, 350);
        },
    },
    beforeDestroy() {
        clearTimeout(this.busquedaTimer);
        this.detenerPollingCrm();
        this.solicitudActual += 1;
    },
    methods: {
        async cargarAsistentes() {
            const solicitud = ++this.solicitudActual;
            if (!this.eventoId) {
                this.asistentes = [];
                this.total = 0;
                return;
            }

            this.cargando = true;
            this.error = '';
            try {
                const response = await axios.get(`/api/qreventos/eventos/${this.eventoId}/credenciales-digitales`, {
                    params: {
                        page: this.paginacion.paginaActual,
                        per_page: this.paginacion.porPagina,
                        buscar: this.busquedaCodigo.trim(),
                        filtro_crm: this.filtroCrm,
                    },
                });
                if (solicitud !== this.solicitudActual) return;
                const data = response.data || {};
                const paginacion = data.paginacion || {};
                this.asistentes = Array.isArray(data.asistentes) ? data.asistentes : [];
                this.total = Number(data.total || 0);
                this.totalGeneral = Number(data.total_general || 0);
                this.resumenCrm = data.resumen_crm || {};
                this.puedeGestionarCrm = !!data.puede_gestionar_crm;
                this.formularioVigente = !!data.formulario_vigente;
                this.formularioCerrado = !!data.formulario_cerrado;
                this.actualizarPollingCrm();
                this.clicsActividadesDifusion = Number(data.clics_actividades_difusion || 0);
                this.paginacion.paginaActual = Number(paginacion.pagina_actual || 1);
                this.paginacion.ultimaPagina = Number(paginacion.ultima_pagina || 1);
                this.paginacion.desde = Number(paginacion.desde || 0);
                this.paginacion.hasta = Number(paginacion.hasta || 0);
            } catch (error) {
                if (solicitud !== this.solicitudActual) return;
                this.asistentes = [];
                this.total = 0;
                this.error = error?.response?.data?.mensaje || error?.response?.data?.message || 'No se pudieron cargar los asistentes de credencial digital.';
            } finally {
                if (solicitud === this.solicitudActual) this.cargando = false;
            }
        },
        detenerPollingCrm() {
            clearInterval(this.pollingCrmTimer);
            this.pollingCrmTimer = null;
        },
        actualizarPollingCrm() {
            const activo = Number(this.resumenCrm.crm_programados || 0) + Number(this.resumenCrm.crm_en_proceso || 0) > 0;
            if (activo && !this.pollingCrmTimer) {
                this.pollingCrmTimer = setInterval(() => {
                    if (!this.cargando) this.cargarAsistentes();
                }, 5000);
            } else if (!activo) {
                this.detenerPollingCrm();
            }
        },
        cambiarFiltroCrm() {
            this.paginacion.paginaActual = 1;
            this.cargarAsistentes();
        },
        async enviarAsistentesCrm() {
            if (!this.puedeGestionarCrm || this.enviandoCrm || !this.totalProgramableCrm) return;
            const eventoId = this.eventoId;
            const result = await Swal.fire({
                icon: 'warning',
                title: 'Enviar asistentes CD al CRM',
                text: `Se agregarán ${this.totalProgramableCrm} registros pendientes o con error a la cola CRM. El formulario de credencial digital quedará cerrado y no aceptará nuevos registros ni modificaciones.`,
                showCancelButton: true,
                confirmButtonText: 'Cerrar formulario y enviar',
                cancelButtonText: 'Cancelar',
            });
            if (!result.isConfirmed || eventoId !== this.eventoId) return;

            this.enviandoCrm = true;
            try {
                const response = await axios.post(`/api/qreventos/eventos/${eventoId}/credenciales-digitales/enviar-crm`);
                if (!response.data?.estado) throw new Error(response.data?.mensaje || 'No se pudo programar el envío CRM.');
                await Swal.fire('Envío programado', response.data.mensaje, 'success');
            } catch (error) {
                await Swal.fire('Error', error?.response?.data?.mensaje || error?.response?.data?.message || error.message, 'error');
            } finally {
                this.enviandoCrm = false;
                await this.cargarAsistentes();
            }
        },
        estadoCrm(asistente) {
            const estados = {
                enviado_ok: ['Enviado', 'badge-success'],
                duplicado: ['Ya registrado', 'badge-info'],
                reenviado_admin_exitoso: ['Enviado', 'badge-success'],
                reenviado_admin_duplicado: ['Ya registrado', 'badge-info'],
                reenvio_programado: ['En cola', 'badge-primary'],
                en_proceso: ['En proceso', 'badge-warning'],
                error_envio: ['Error', 'badge-danger'],
                reenviado_admin_error: ['Error', 'badge-danger'],
            };
            return estados[asistente.estado_crm] || ['Pendiente', 'badge-secondary'];
        },
        verRespuestaCrm(asistente) {
            Swal.fire({
                title: `Respuesta CRM: ${asistente.codigo}`,
                text: JSON.stringify(asistente.resp_crm || { mensaje: asistente.ultimo_error_crm || 'Sin respuesta CRM.' }, null, 2),
                width: 760,
                confirmButtonText: 'Cerrar',
            });
        },
        limpiarBusqueda() {
            this.busquedaCodigo = '';
        },
        cambiarPagina(pagina) {
            if (pagina < 1 || pagina > this.paginacion.ultimaPagina || pagina === this.paginacion.paginaActual) {
                return;
            }
            this.paginacion.paginaActual = pagina;
            this.cargarAsistentes();
        },
        async confirmarEliminacion(asistente) {
            const primeraConfirmacion = await Swal.fire({
                icon: 'warning',
                title: '¿Eliminar registro?',
                html: `Se eliminará el registro <strong>${asistente.codigo}</strong> asociado al documento <strong>${asistente.documento}</strong>.`,
                showCancelButton: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#dc3545',
            });

            if (!primeraConfirmacion.isConfirmed) {
                return;
            }

            const segundaConfirmacion = await Swal.fire({
                icon: 'error',
                title: 'Confirmación final',
                text: 'Esta acción no se puede deshacer. ¿Confirma definitivamente la eliminación?',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar definitivamente',
                cancelButtonText: 'No eliminar',
                confirmButtonColor: '#dc3545',
            });

            if (!segundaConfirmacion.isConfirmed) {
                return;
            }

            await this.eliminarAsistente(asistente);
        },
        async eliminarAsistente(asistente) {
            this.eliminandoId = asistente.id;
            try {
                const response = await axios.post(`/api/qreventos/eventos/${this.eventoId}/credenciales-digitales/${asistente.id}/eliminar`);
                if (!response.data || !response.data.estado) {
                    throw new Error(response.data?.mensaje || 'No se pudo eliminar el registro.');
                }

                if (this.asistentes.length === 1 && this.paginacion.paginaActual > 1) {
                    this.paginacion.paginaActual -= 1;
                }
                await this.cargarAsistentes();
                await Swal.fire('Registro eliminado', response.data.mensaje, 'success');
            } catch (error) {
                await Swal.fire('Error', error?.response?.data?.mensaje || error?.response?.data?.message || error?.message || 'No se pudo eliminar el registro.', 'error');
            } finally {
                this.eliminandoId = null;
            }
        },
        nombreCompleto(asistente) {
            return [asistente.nombres, asistente.apellido_paterno, asistente.apellido_materno]
                .filter(Boolean)
                .join(' ') || '-';
        },
        textoCarreras(asistente) {
            return Array.isArray(asistente.carreras) && asistente.carreras.length
                ? asistente.carreras.join(', ')
                : '-';
        },
    },
};
</script>

<template>
    <div class="asistentes-cd">
        <div v-if="formularioCerrado" class="alert alert-warning">Formulario cerrado por inicio del envío CRM.</div>
        <div v-else-if="!formularioVigente && !cargando && !error" class="alert alert-warning">Formulario no disponible: finalizó su fecha de término o no tiene una fecha de término válida.</div>
        <div v-if="linkFormularioEvento && formularioVigente" class="mb-2 asistentes-cd__link">
            <span class="text-muted mr-1">Formulario del evento:</span>
            <a :href="linkFormularioEvento" target="_blank" rel="noopener noreferrer">{{ linkFormularioEvento }}</a>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="d-flex flex-wrap align-items-center">
                <span class="badge badge-primary mr-2 mb-1">Usuarios registrados: {{ totalGeneral }}</span>
                <span class="badge badge-info mb-1">Actividades de difusión consultadas: {{ clicsActividadesDifusion }}</span>
            </div>
            <b-button size="sm" variant="outline-primary" :disabled="cargando" @click="cargarAsistentes">
                <b-spinner v-if="cargando" small class="mr-1"></b-spinner>
                {{ cargando ? 'Actualizando...' : 'Actualizar' }}
            </b-button>
        </div>

        <div v-if="puedeGestionarCrm" class="asistentes-cd__crm mb-3">
            <div class="asistentes-cd__resumen">
                <div><small>Total CD</small><strong>{{ totalGeneral }}</strong></div>
                <div><small>Gestionados CRM</small><strong>{{ resumenCrm.crm_enviados || 0 }}</strong></div>
                <div><small>Pendientes</small><strong>{{ resumenCrm.crm_pendientes || 0 }}</strong></div>
                <div><small>En cola / proceso</small><strong>{{ Number(resumenCrm.crm_programados || 0) + Number(resumenCrm.crm_en_proceso || 0) }}</strong></div>
                <div><small>Errores</small><strong class="text-danger">{{ resumenCrm.crm_errores || 0 }}</strong></div>
            </div>
            <div class="progress mt-3" style="height: 8px;">
                <div class="progress-bar" role="progressbar" :style="{ width: `${crmProgreso}%` }" :aria-valuenow="crmProgreso" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div class="d-flex flex-wrap justify-content-between align-items-center mt-2 asistentes-cd__acciones">
                <span class="small text-muted">Avance: {{ crmProcesados }} de {{ totalGeneral }} ({{ crmProgreso }}%)</span>
                <b-button size="sm" variant="success" :disabled="enviandoCrm || cargando || totalProgramableCrm === 0" @click="enviarAsistentesCrm">
                    <i class="bx bx-upload mr-1"></i>
                    {{ enviandoCrm ? 'Agregando a la cola...' : `Enviar ${totalProgramableCrm} pendientes a CRM` }}
                </b-button>
            </div>
        </div>

        <div class="form-row align-items-end mb-3">
            <div class="col-md-5 col-lg-4">
                <label for="buscar-codigo-cd" class="mb-1">Buscar por código CD o RUT</label>
                <b-form-input
                    id="buscar-codigo-cd"
                    v-model="busquedaCodigo"
                    placeholder="Ejemplo: CD-A7K o 12.345.678-9"
                    maxlength="40"
                ></b-form-input>
            </div>
            <div class="col-auto mt-2 mt-md-0">
                <b-button v-if="busquedaCodigo" variant="outline-secondary" :disabled="cargando" @click="limpiarBusqueda">Limpiar</b-button>
            </div>
            <div class="col-md-3 mt-2 mt-md-0">
                <label for="filtro-crm-cd" class="mb-1">Estado CRM</label>
                <b-form-select id="filtro-crm-cd" v-model="filtroCrm" @change="cambiarFiltroCrm">
                    <option value="todos">Todos</option>
                    <option value="pendientes">Pendientes</option>
                    <option value="enviados">Gestionados CRM</option>
                    <option value="errores">Con error</option>
                </b-form-select>
            </div>
        </div>

        <div v-if="error" class="alert alert-danger">{{ error }}</div>
        <div v-else-if="cargando && !asistentes.length" class="text-center text-muted py-4">
            <b-spinner small class="mr-2"></b-spinner>Cargando asistentes...
        </div>
        <div v-else-if="asistentes.length" class="table-responsive mb-0">
            <table class="table table-hover table-sm asistentes-cd__table">
                <thead>
                    <tr>
                        <th>Nº</th>
                        <th>Código CD</th>
                        <th>Ingresos</th>
                        <th>Documento</th>
                        <th>Nombre</th>
                        <th>Curso</th>
                        <th>Celular</th>
                        <th>Email</th>
                        <th>RBD</th>
                        <th>Campus / carrera</th>
                        <th>Fecha registro</th>
                        <th>CRM</th>
                        <th>Acción</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(asistente, indice) in asistentes" :key="asistente.id">
                        <td>{{ paginacion.desde + indice }}</td>
                        <td>
                            <span class="asistentes-cd__codigo">
                                <strong>{{ asistente.codigo || '-' }}</strong>
                                <i
                                    :class="Number(asistente.intentos || 1) > 1 ? 'fas fa-pen asistentes-cd__estado-icon asistentes-cd__estado-icon--updated' : 'fas fa-check-circle asistentes-cd__estado-icon asistentes-cd__estado-icon--created'"
                                    :title="Number(asistente.intentos || 1) > 1 ? 'Registro actualizado' : 'Registro creado'"
                                    :aria-label="Number(asistente.intentos || 1) > 1 ? 'Registro actualizado' : 'Registro creado'"
                                ></i>
                            </span>
                        </td>
                        <td>
                            <span :class="['badge', Number(asistente.intentos || 1) > 1 ? 'badge-warning' : 'badge-light']">
                                {{ Number(asistente.intentos || 1) }}
                            </span>
                        </td>
                        <td>
                            <div>{{ asistente.documento || '-' }}</div>
                            <small class="text-muted text-uppercase">{{ asistente.tipo_documento || '-' }}</small>
                        </td>
                        <td>{{ nombreCompleto(asistente) }}</td>
                        <td>{{ asistente.curso || '-' }}</td>
                        <td>{{ asistente.celular || '-' }}</td>
                        <td>{{ asistente.email || '-' }}</td>
                        <td>{{ asistente.colegio_rbd || '-' }}</td>
                        <td>
                            <div>{{ asistente.campus || '-' }}</div>
                            <small class="text-muted">{{ textoCarreras(asistente) }}</small>
                        </td>
                        <td>{{ asistente.fecha_registro || '-' }}</td>
                        <td>
                            <span class="badge" :class="estadoCrm(asistente)[1]">{{ estadoCrm(asistente)[0] }}</span>
                            <small v-if="asistente.ultimo_error_crm" class="d-block text-danger asistentes-cd__error">{{ asistente.ultimo_error_crm }}</small>
                            <small v-if="asistente.reintentos_crm" class="d-block text-muted">Intentos: {{ asistente.reintentos_crm }}</small>
                            <b-button v-if="asistente.resp_crm || asistente.ultimo_error_crm" size="sm" variant="link" title="Ver respuesta e historial CRM" aria-label="Ver respuesta e historial CRM" @click="verRespuestaCrm(asistente)">
                                <i class="bx bx-show"></i>
                            </b-button>
                        </td>
                        <td>
                            <b-button
                                size="sm"
                                variant="danger"
                                title="Eliminar registro"
                                aria-label="Eliminar registro"
                                :disabled="eliminandoId !== null || enviandoCrm || formularioCerrado || asistente.estado_crm !== 'pendiente_envio'"
                                @click="confirmarEliminacion(asistente)"
                            >
                                <b-spinner v-if="eliminandoId === asistente.id" small></b-spinner>
                                <svg v-else class="asistentes-cd__trash-icon" viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M9 3h6l1 2h4v2H4V5h4l1-2Zm-2 6h10l-1 11H8L7 9Zm3 2v7h2v-7h-2Zm4 0v7h2v-7h-2Z" fill="currentColor"/>
                                </svg>
                            </b-button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else class="text-center text-muted py-4">
            No hay asistentes que coincidan con los filtros seleccionados.
        </div>

        <div v-if="paginacion.ultimaPagina > 1" class="d-flex justify-content-between align-items-center mt-3">
            <small class="text-muted">Mostrando {{ paginacion.desde }}–{{ paginacion.hasta }} de {{ total }}</small>
            <div>
                <b-button size="sm" variant="outline-secondary" class="mr-2" :disabled="cargando || paginacion.paginaActual <= 1" @click="cambiarPagina(paginacion.paginaActual - 1)">
                    Anterior
                </b-button>
                <span class="small mr-2">Página {{ paginacion.paginaActual }} de {{ paginacion.ultimaPagina }}</span>
                <b-button size="sm" variant="outline-secondary" :disabled="cargando || paginacion.paginaActual >= paginacion.ultimaPagina" @click="cambiarPagina(paginacion.paginaActual + 1)">
                    Siguiente
                </b-button>
            </div>
        </div>
    </div>
</template>

<style scoped>
.asistentes-cd__crm {
    padding: 16px 0;
    border-top: 1px solid #dee2e6;
    border-bottom: 1px solid #dee2e6;
}

.asistentes-cd__resumen {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
    gap: 12px;
}

.asistentes-cd__resumen small,
.asistentes-cd__resumen strong {
    display: block;
}

.asistentes-cd__resumen strong {
    font-size: 20px;
}

.asistentes-cd__acciones {
    gap: 12px;
}

.asistentes-cd__link {
    overflow-wrap: anywhere;
}

.asistentes-cd__error {
    min-width: 160px;
    max-width: 250px;
    overflow-wrap: anywhere;
}

.asistentes-cd__table {
    min-width: 1250px;
}

.asistentes-cd__table th {
    white-space: nowrap;
}

.asistentes-cd__codigo {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    white-space: nowrap;
}

.asistentes-cd__estado-icon {
    font-size: 11px;
}

.asistentes-cd__estado-icon--created {
    color: #218838;
}

.asistentes-cd__estado-icon--updated {
    color: #d39e00;
}

.asistentes-cd__table th:last-child,
.asistentes-cd__table td:last-child {
    position: sticky;
    right: 0;
    z-index: 1;
    min-width: 64px;
    background: #fff;
    text-align: center;
}

.asistentes-cd__table th:last-child {
    z-index: 2;
}

.asistentes-cd__trash-icon {
    display: block;
    width: 16px;
    height: 16px;
}
</style>
